import * as ko from 'knockout'
import template from './finishers.list.tpl.html'
import { FinishersListViewModel, Params } from './FinishersListViewModel'

if (!ko.components.isRegistered('finishers-list')) {
  ko.components.register('finishers-list', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new FinishersListViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
